/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ProfileApiDataTransferObjectsFullProfileEnumsMembershipStatus {
  Active = "Active",
  Suspended = "Suspended",
}

export enum ProfileApiDataProfileDbEntitiesEnumsMediaType {
  Audio = "Audio",
  Video = "Video",
}

export enum ProfileApiDataProfileDbEntitiesEnumsMeasurementType {
  None = "None",
  Height = "Height",
  Weight = "Weight",
  Chest = "Chest",
  Waist = "Waist",
  Hips = "Hips",
  InsideLeg = "InsideLeg",
  InsideArm = "InsideArm",
  Collar = "Collar",
  Hat = "Hat",
  Shoes = "Shoes",
  Dress = "Dress",
  LowerVocalNote = "LowerVocalNote",
  UpperVocalNote = "UpperVocalNote",
}

export enum ProfileApiCommonModelsEnumsPlatform {
  Spotlight = "Spotlight",
  StagePool = "StagePool",
  FilmMakers = "FilmMakers",
}

export enum ProfileApiCommonModelsEnumsPerformerType {
  YoungPerformer = "YoungPerformer",
  Graduate = "Graduate",
  Performer = "Performer",
  Stagepool = "Stagepool",
  Filmmakers = "Filmmakers",
}

export enum MicrosoftAspNetCoreJsonPatchOperationsOperationType {
  Add = "Add",
  Remove = "Remove",
  Replace = "Replace",
  Move = "Move",
  Copy = "Copy",
  Test = "Test",
  Invalid = "Invalid",
}

export interface BaseModelsNotificationsTagminAvailabilityNotification {
  event?: string | null;
  item?: string | null;
  itemId?: string | null;
  /** @format int32 */
  agencyId?: number;
  /** @format uuid */
  clientGuid?: string | null;
  endpoint?: string | null;
}

export interface MicrosoftAspNetCoreJsonPatchOperationsOperation {
  operationType?: MicrosoftAspNetCoreJsonPatchOperationsOperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProfileApiCommonExceptionsModelValidationError {
  description?: string | null;
}

export interface ProfileApiCommonModelsApiEndpointsCreateProfileRequest {
  artistRef?: string | null;
  viewPin?: string | null;
  forename?: string | null;
  surname?: string | null;
  performerType?: ProfileApiCommonModelsEnumsPerformerType;
  platform?: ProfileApiCommonModelsEnumsPlatform;
  /** @format int32 */
  playingAgeFrom?: number;
  /** @format int32 */
  playingAgeTo?: number;
  mainPhotoPhotographerName?: string | null;
  mainPhotoDescription?: string | null;
  mainPhotoUrl?: string | null;
}

export interface ProfileApiCommonModelsApiEndpointsCreateProfileResponse {
  /** @format uuid */
  profileId?: string;
  viewPin?: string | null;
  problems?: string[] | null;
}

export interface ProfileApiDataTransferObjectsBasicInfoBasicInfoDto {
  /** @format uuid */
  profileId?: string;
  isPregnant?: boolean;
  /** @format date-time */
  pregnantUntil?: string | null;
  hasTwin?: boolean;
  /** @format int32 */
  playingAgeFrom?: number | null;
  /** @format int32 */
  playingAgeTo?: number | null;
  isVisibleActualAge?: boolean;
  age?: string | null;
  /** @format int32 */
  vocalAgeFrom?: number | null;
  /** @format int32 */
  vocalAgeTo?: number | null;
  hasDisability?: boolean;
  disabilityInfo?: string | null;
  isVisibleDisability?: boolean;
  genderInfo?: string | null;
  isVisibleGender?: boolean;
  heritageAndEthnicityInfo?: string | null;
  isVisibleHeritageAndEthnicity?: boolean;
  isVisibleVisasAndPermits?: boolean;
  makeUp?: string | null;
  isLicenseRequired?: boolean | null;
  measurements?: ProfileApiDataTransferObjectsBasicInfoMeasurementDto[] | null;
  facets?: ProfileApiDataTransferObjectsBasicInfoFacetDto[] | null;
  locations?: ProfileApiDataTransferObjectsBasicInfoLocationDto[] | null;
  hasPremiumCalendar?: boolean;
}

export interface ProfileApiDataTransferObjectsBasicInfoFacetDto {
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  position?: number | null;
}

export interface ProfileApiDataTransferObjectsBasicInfoLocationDto {
  googlePlaceId?: string | null;
  /** @format int32 */
  position?: number | null;
}

export interface ProfileApiDataTransferObjectsBasicInfoMeasurementDto {
  measurementType?: ProfileApiDataProfileDbEntitiesEnumsMeasurementType;
  /** @format double */
  value?: number;
}

export interface ProfileApiDataTransferObjectsCreditsCreditDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  /** @format uuid */
  id?: string;
  name?: string | null;
  dateFromFormat?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  dateToFormat?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format int32 */
  typeId?: number;
  role?: string | null;
  company?: string | null;
  venue?: string | null;
  director?: string | null;
  highlighted?: boolean;
  /** @format int32 */
  position?: number;
}

export interface ProfileApiDataTransferObjectsCreditsCreditHeadingDto {
  /** @format uuid */
  profileId?: string;
  creditType?: ProfileApiDataTransferObjectsCreditsCreditTypeDto;
  isHidden?: boolean;
  /** @format int32 */
  position?: number;
  orderByDate?: boolean;
}

export interface ProfileApiDataTransferObjectsCreditsCreditTypeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  hasVenue?: boolean;
}

export interface ProfileApiDataTransferObjectsCreditsGetCreditsResponseDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  credits?: ProfileApiDataTransferObjectsCreditsCreditDto[] | null;
  creditHeadings?:
    | ProfileApiDataTransferObjectsCreditsCreditHeadingDto[]
    | null;
}

export interface ProfileApiDataTransferObjectsCreditsProductionTypesDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  creditTypes?: ProfileApiDataTransferObjectsCreditsCreditTypeDto[] | null;
}

export interface ProfileApiDataTransferObjectsCreditsViewModelsCreditViewModel {
  name?: string | null;
  dateFromFormat?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  dateToFormat?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format int32 */
  typeId?: number | null;
  role?: string | null;
  company?: string | null;
  venue?: string | null;
  director?: string | null;
  highlighted?: boolean | null;
}

export interface ProfileApiDataTransferObjectsCreditsViewModelsPatchCreditHeadingViewModel {
  /** @format int32 */
  creditTypeId?: number;
  isHidden?: boolean | null;
  /** @format int32 */
  position?: number | null;
  orderByDate?: boolean | null;
}

export interface ProfileApiDataTransferObjectsCreditsViewModelsPutCreditViewModel {
  name?: string | null;
  dateFromFormat?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  dateToFormat?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format int32 */
  typeId?: number | null;
  role?: string | null;
  company?: string | null;
  venue?: string | null;
  director?: string | null;
  highlighted?: boolean | null;
  /** @format uuid */
  id?: string | null;
}

export interface ProfileApiDataTransferObjectsEmailAgentToSelfRepresentedEmailViewModel {
  /** @maxLength 3000 */
  message?: string | null;
  subject?: string | null;
  /** @minLength 1 */
  senderName: string;
  /**
   * @format email
   * @minLength 1
   */
  senderEmail: string;
  senderTelephoneNumber?: string | null;
  /** @maxLength 75 */
  companyName?: string | null;
  /** @maxLength 75 */
  companyWebsite?: string | null;
}

export interface ProfileApiDataTransferObjectsEmailSelfRepresentedEmailViewModel {
  /** @maxLength 3000 */
  message?: string | null;
  subject?: string | null;
  /** @minLength 1 */
  senderName: string;
  /**
   * @format email
   * @minLength 1
   */
  senderEmail: string;
  senderTelephoneNumber?: string | null;
  /** @maxLength 75 */
  companyName?: string | null;
  /** @maxLength 75 */
  companyWebsite?: string | null;
  attachments?: string[] | null;
}

export interface ProfileApiDataTransferObjectsEmailShareProfileEmailViewModel {
  /** @maxLength 10000 */
  message?: string | null;
  /** @maxLength 500 */
  subject?: string | null;
  /** @maxItems 500 */
  recipients?: string[] | null;
  /** @maxLength 250 */
  senderName?: string | null;
  /**
   * @format email
   * @maxLength 254
   */
  senderEmail?: string | null;
}

export interface ProfileApiDataTransferObjectsFileValidationDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  status?: string | null;
  errorStatuses?: string[] | null;
  fileName?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextAboutMeDto {
  /** @format uuid */
  id?: string;
  currentAppearance?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextAboutMeViewModel {
  /** @maxLength 2000 */
  currentAppearance?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextProfileIdentityDto {
  /** @format uuid */
  id?: string;
  pronouns?: string | null;
  pronunciation?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextProfileIdentityRequest {
  pronouns?: string | null;
  pronunciation?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextTrainingDto {
  /** @format uuid */
  id?: string;
  notes?: string | null;
}

export interface ProfileApiDataTransferObjectsFreeTextTrainingViewModel {
  /** @maxLength 1500 */
  notes?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileAddressDto {
  /** @format int32 */
  id?: number;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  country?: string | null;
  postCode?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileAgentDto {
  /** @format int32 */
  refNumber?: number;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  phone2?: string | null;
  mobilePhone?: string | null;
  website?: string | null;
  description?: string | null;
  address?: ProfileApiDataTransferObjectsFullProfileAddressDto;
  address2?: ProfileApiDataTransferObjectsFullProfileAddressDto;
  revealAddress2?: boolean;
  email2?: string | null;
  phone3?: string | null;
  phone4?: string | null;
  mobilePhone2?: string | null;
  website2?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileContractDto {
  membership?: string | null;
  status?: string | null;
  /** @format date-time */
  expirationDate?: string;
}

export interface ProfileApiDataTransferObjectsFullProfileDramaSchoolDto {
  /** @format int32 */
  refNumber?: number;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  phone2?: string | null;
  mobilePhone?: string | null;
  website?: string | null;
  description?: string | null;
  address?: ProfileApiDataTransferObjectsFullProfileAddressDto;
  address2?: ProfileApiDataTransferObjectsFullProfileAddressDto;
  revealAddress2?: boolean;
}

export interface ProfileApiDataTransferObjectsFullProfileFullProfileDto {
  /** @format uuid */
  id?: string;
  artistRef?: string | null;
  mainPhoto?: ProfileApiDataTransferObjectsFullProfileMainPhotoDto;
  galleryPhotos?:
    | ProfileApiDataTransferObjectsFullProfileGalleryPhotoDto[]
    | null;
  forename?: string | null;
  surname?: string | null;
  performerType?: ProfileApiCommonModelsEnumsPerformerType;
  /** @format int32 */
  publicationCode?: number;
  membershipStatus?: ProfileApiDataTransferObjectsFullProfileEnumsMembershipStatus;
  contract?: ProfileApiDataTransferObjectsFullProfileContractDto;
  mainAgent?: ProfileApiDataTransferObjectsFullProfileAgentDto;
  agents?: ProfileApiDataTransferObjectsFullProfileAgentDto[] | null;
  isSelfRepresented?: boolean;
  hasAgent?: boolean;
  isLookingForRepresentation?: boolean;
  /** @format date-time */
  isLookingForRepresentationTimestamp?: string | null;
  dramaSchools?:
    | ProfileApiDataTransferObjectsFullProfileDramaSchoolDto[]
    | null;
  /** @format int32 */
  showreelsCount?: number;
  /** @format int32 */
  audioclipsCount?: number;
  locations?: ProfileApiDataTransferObjectsFullProfileLocationDto[] | null;
  accentsAndDialects?:
    | ProfileApiDataTransferObjectsSkillsProfileSkillDto[]
    | null;
  vehicleLicences?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  languages?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  musicAndDance?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  otherSkills?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  performances?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  sports?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  presenting?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  skills?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  voiceOver?: ProfileApiDataTransferObjectsSkillsProfileSkillDto[] | null;
  gender?: number[] | null;
  disabilities?: number[] | null;
  nationalities?: number[] | null;
  memberships?: number[] | null;
  appearances?: number[] | null;
  eyeColours?: number[] | null;
  facialHairs?: number[] | null;
  hairColours?: number[] | null;
  hairLength?: number[] | null;
  voiceStyles?: number[] | null;
  membershipBodies?: number[] | null;
  beltNotes?: number[] | null;
  heritageAndEthnicity?: number[] | null;
  visasAndPermits?: number[] | null;
  facets?: ProfileApiDataTransferObjectsBasicInfoFacetDto[] | null;
  isPregnant?: boolean;
  /** @format date-time */
  pregnantUntil?: string | null;
  /** @format int32 */
  playingAgeFrom?: number | null;
  /** @format int32 */
  playingAgeTo?: number | null;
  /** @format date-time */
  dateOfBirthUtc?: string | null;
  /** @format double */
  height?: number | null;
  viewPin?: string | null;
  disabilityInfo?: string | null;
  genderInfo?: string | null;
  heritageAndEthnicityInfo?: string | null;
  makeUp?: string | null;
  measurements?: ProfileApiDataTransferObjectsBasicInfoMeasurementDto[] | null;
  credits?: ProfileApiDataTransferObjectsCreditsCreditDto[] | null;
  productionTypeCreditQuantities?:
    | ProfileApiDataTransferObjectsFullProfileProductionTypeCreditQuantity[]
    | null;
  creditHeadings?:
    | ProfileApiDataTransferObjectsCreditsCreditHeadingDto[]
    | null;
  castingDirectorNotes?:
    | ProfileApiDataTransferObjectsNotesArtistCastingDirectorNoteDto[]
    | null;
  isVisibleActualAge?: boolean;
  isVisibleDisability?: boolean;
  isVisibleGender?: boolean;
  isVisibleHeritageAndEthnicity?: boolean;
  isVisibleVisasAndPermits?: boolean;
  aboutMe?: string | null;
  training?: string | null;
  /** @format int32 */
  creditQty?: number;
  unavailabilities?:
    | ProfileApiDataTransferObjectsFullProfileUnavailabilityDto[]
    | null;
  tagminAvailability?:
    | ProfileApiDataTransferObjectsFullProfileTagminAvailabilityDto[]
    | null;
  socialMediaAccounts?:
    | ProfileApiDataTransferObjectsFullProfileSocialMediaAccountEsDto[]
    | null;
  profileIdentity?: ProfileApiDataTransferObjectsFullProfileProfileIdentityDto;
}

export interface ProfileApiDataTransferObjectsFullProfileGalleryPhotoDto {
  /** @format uuid */
  id?: string;
  fileName?: string | null;
  description?: string | null;
  photographer?: ProfileApiDataTransferObjectsFullProfilePhotographerDto;
  /** @format int32 */
  position?: number;
  isHidden?: boolean;
}

export interface ProfileApiDataTransferObjectsFullProfileLocationDto {
  locationId?: string | null;
  /** @format int32 */
  position?: number;
}

export interface ProfileApiDataTransferObjectsFullProfileMainPhotoDto {
  /** @format uuid */
  id?: string;
  fileName?: string | null;
  description?: string | null;
  photographer?: ProfileApiDataTransferObjectsFullProfilePhotographerDto;
}

export interface ProfileApiDataTransferObjectsFullProfilePhotographerDto {
  name?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileProductionTypeCreditQuantity {
  /** @format int32 */
  productionTypeId?: number;
  /** @format int32 */
  creditQty?: number;
}

export interface ProfileApiDataTransferObjectsFullProfileProfileIdentityDto {
  pronouns?: string | null;
  pronunciation?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileSocialMediaAccountEsDto {
  /** @format int32 */
  id?: number;
  platformCode?: string | null;
  username?: string | null;
  profileUrl?: string | null;
  /** @format date-time */
  tokenExpiresAt?: string | null;
}

export interface ProfileApiDataTransferObjectsFullProfileTagminAvailabilityDto {
  externalId?: string | null;
  externalParentId?: string | null;
  projectId?: string | null;
  /** @format uuid */
  profileId?: string;
  /** @format date-time */
  startDateUtc?: string;
  /** @format date-time */
  endDateUtc?: string | null;
  title?: string | null;
  type?: string | null;
  category?: string | null;
  notes?: string | null;
  colour?: string | null;
  toBeConfirmed?: boolean;
  allDay?: boolean;
  visible?: boolean;
  /** @format int32 */
  agencyOrgId?: number;
  hide?: boolean;
}

export interface ProfileApiDataTransferObjectsFullProfileUnavailabilityDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  title?: string | null;
  note?: string | null;
  externalShared?: boolean;
}

export interface ProfileApiDataTransferObjectsHalJsonHalLink {
  href?: string | null;
  templated?: boolean | null;
}

export interface ProfileApiDataTransferObjectsHalJsonHalLinks {
  linkValues?: Record<
    string,
    ProfileApiDataTransferObjectsHalJsonHalLink
  > | null;
  self?: ProfileApiDataTransferObjectsHalJsonHalLink;
  prev?: ProfileApiDataTransferObjectsHalJsonHalLink;
  next?: ProfileApiDataTransferObjectsHalJsonHalLink;
  fileUploadStatus?: ProfileApiDataTransferObjectsHalJsonHalLink;
  find?: ProfileApiDataTransferObjectsHalJsonHalLink;
  makeMain?: ProfileApiDataTransferObjectsHalJsonHalLink;
  patchPhoto?: ProfileApiDataTransferObjectsHalJsonHalLink;
  gallery?: ProfileApiDataTransferObjectsHalJsonHalLink;
  mainPhoto?: ProfileApiDataTransferObjectsHalJsonHalLink;
  photographers?: ProfileApiDataTransferObjectsHalJsonHalLink;
  reject?: ProfileApiDataTransferObjectsHalJsonHalLink;
  approve?: ProfileApiDataTransferObjectsHalJsonHalLink;
  auditLog?: ProfileApiDataTransferObjectsHalJsonHalLink;
  filter?: ProfileApiDataTransferObjectsHalJsonHalLink;
  credits?: ProfileApiDataTransferObjectsHalJsonHalLink;
  photo?: ProfileApiDataTransferObjectsHalJsonHalLink;
}

export interface ProfileApiDataTransferObjectsNotesViewModelsCastingDirectorNoteViewModel {
  /** @maxLength 1000 */
  content?: string | null;
}

export interface ProfileApiDataTransferObjectsPhotographersDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  names?: string[] | null;
}

export interface ProfileApiDataTransferObjectsPhotosGalleryPhotoDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  /** @format uuid */
  id?: string;
  url?: string | null;
  isHidden?: boolean;
  isPreviouslyMain?: boolean;
  userFriendlyId?: string | null;
  description?: string | null;
  photographer?: string | null;
}

export interface ProfileApiDataTransferObjectsPhotosGalleryPhotosDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  photos?: ProfileApiDataTransferObjectsPhotosGalleryPhotoDto[] | null;
}

export interface ProfileApiDataTransferObjectsPhotosMainPhotoDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  /** @format uuid */
  id?: string;
  url?: string | null;
  photographer?: string | null;
  userFriendlyId?: string | null;
  description?: string | null;
}

export interface ProfileApiDataTransferObjectsPhotosPostPhotoViewModel {
  fileName?: string | null;
  url?: string | null;
  photographerName?: string | null;
  description?: string | null;
  isHidden?: boolean;
}

export interface ProfileApiDataTransferObjectsPhotosPutGalleryItemViewModel {
  /** @format uuid */
  id?: string | null;
  fileName?: string | null;
  url?: string | null;
  photographerName?: string | null;
  description?: string | null;
  isHidden?: boolean;
}

export interface ProfileApiDataTransferObjectsPhotosPutGalleryViewModel {
  photos?: ProfileApiDataTransferObjectsPhotosPutGalleryItemViewModel[] | null;
}

export interface ProfileApiDataTransferObjectsProfileMediaCreateProfileMediaViewModel {
  /** @format uuid */
  mediaInfoId: string;
  mediaType: ProfileApiDataProfileDbEntitiesEnumsMediaType;
  visible: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** @maxLength 250 */
  description?: string | null;
  /** @format int32 */
  durationInMs?: number | null;
}

export interface ProfileApiDataTransferObjectsProfileSettingsProfileSettingsDto {
  /** @format int32 */
  discoveryScreensCompletions?: number;
  /** @format int32 */
  discoveryScreensCreditsCompletions?: number;
  /** @format int32 */
  discoveryScreensBasicInfoCompletions?: number;
  /** @format int32 */
  discoveryScreensProfileCompletions?: number;
  furtherCreditsOrderByDate?: boolean;
}

export interface ProfileApiDataTransferObjectsProfilesExtendedProfileDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  /** @format uuid */
  id?: string;
  viewPin?: string | null;
  artistRef?: string | null;
  forename?: string | null;
  surname?: string | null;
  mainPhoto?: ProfileApiDataTransferObjectsProfilesExtendedProfileDtoExtendedProfileDtoPhoto;
  photos?:
    | ProfileApiDataTransferObjectsProfilesExtendedProfileDtoExtendedProfileDtoPhoto[]
    | null;
}

export interface ProfileApiDataTransferObjectsProfilesExtendedProfileDtoExtendedProfileDtoPhoto {
  /** @format uuid */
  id?: string;
  fileName?: string | null;
}

export interface ProfileApiDataTransferObjectsProfilesProfileDto {
  links?: ProfileApiDataTransferObjectsHalJsonHalLinks;
  /** @format uuid */
  profileId?: string;
  forename?: string | null;
  surname?: string | null;
  artistRef?: string | null;
  /** @format int32 */
  artistType?: number;
  viewPin?: string | null;
}

export interface ProfileApiDataTransferObjectsProfilesSearchBulkViewModel {
  artistReferences?: string[] | null;
  includeGalleryPhotos?: boolean;
}

export interface ProfileApiDataTransferObjectsProfilesSearchViewModel {
  artistReferences?: string[] | null;
}

export interface ProfileApiDataTransferObjectsSkillsCreateProfileSkillViewModel {
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  levelId?: number | null;
}

export interface ProfileApiDataTransferObjectsSkillsProfileSkillDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  facetCategoryId?: number;
  /** @format int32 */
  levelId?: number | null;
}

export interface ProfileApiDataTransferObjectsSkillsUpdateProfileSkillViewModel {
  /** @format int32 */
  levelId?: number | null;
}

export interface ProfileApiDataTransferObjectsSocialMediaSocialMediaDto {
  /** @format uuid */
  id?: string;
  website?: string | null;
}

export interface ProfileApiDataTransferObjectsSocialMediaSocialMediaViewModel {
  /** @maxLength 100 */
  website?: string | null;
}

export interface ProfileApiDataTransferObjectsUnavailabilityUnavailabilityDto {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  title?: string | null;
  note?: string | null;
  externalShared?: boolean;
  /** @format uuid */
  id?: string;
}

export interface ProfileApiDataTransferObjectsUnavailabilityViewModelsUnavailabilityViewModel {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  title?: string | null;
  note?: string | null;
  externalShared?: boolean;
}

export interface ProfileApiDataTransferObjectsNotesArtistCastingDirectorNoteDto {
  content?: string | null;
  /** @format uuid */
  madeBy?: string;
}

export type ProfileApiDataTransferObjectsNotesCastingDirectorNoteDto = object;

export interface ProfileApiWebCommonModelsMessageDto {
  message?: string | null;
}

export interface ProfileApiWebModelsRequestsFilmMakerNotification {
  type?: string | null;
  /** @format int64 */
  created?: number;
  data?: Record<string, any> | null;
}

export interface ProfileApiWebModelsRequestsProfileMediaDtoPropertyPatch {
  path?: string | null;
  value?: string | null;
  op?: string | null;
}

export interface ProfileApiWebModelsResponsesMediaAllocationDto {
  /** @format int32 */
  maxAllowedUpload?: number;
  /** @format int32 */
  maxAllowedVisible?: number;
}

export interface ProfileApiWebModelsResponsesProfileMediaAllocationDto {
  audio?: ProfileApiWebModelsResponsesMediaAllocationDto;
  video?: ProfileApiWebModelsResponsesMediaAllocationDto;
}

export interface ProfileApiWebModelsResponsesProfileMediaBaseDto {
  /** @format uuid */
  id?: string;
  visible?: boolean;
  /** @format int32 */
  sortOrder?: number;
  /** @format int32 */
  mergedSortOrder?: number;
  /** @format int32 */
  selectedThumbnail?: number | null;
  /** @format uuid */
  mediaInfoId?: string;
  /** @format uuid */
  profileId?: string;
  mediaType?: string | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  durationInMs?: number | null;
  thumbnail?: string | null;
  url?: string | null;
}

export interface ProfileApiWebModelsResponsesViewMediaDto {
  artistName?: string | null;
  media?: ProfileApiWebModelsResponsesProfileMediaBaseDto[] | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Profile API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  profiles = {
    /**
     * @description Sample request: GET /profiles/{profile_id}/aboutme/
     *
     * @tags AboutMe
     * @name AboutMeGetAboutMe
     * @summary Information about performers current appearance
     * @request GET:/profiles/{profileId}/aboutme
     * @secure
     */
    aboutMeGetAboutMe: <
      TResponse = ProfileApiDataTransferObjectsFreeTextAboutMeDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/aboutme`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: PUT /profiles/31c39315-238c-4718-b48f-26ee8456d81f/aboutme/ { "currentAppearance":"2014 - Lorem Ipsum\n\nDolor sit amet" }
     *
     * @tags AboutMe
     * @name AboutMePutAboutMe
     * @summary Updates performers current appearance
     * @request PUT:/profiles/{profileId}/aboutme
     * @secure
     */
    aboutMePutAboutMe: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsFreeTextAboutMeViewModel,
      query?: {
        spotlightUserRequiresApproval?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/aboutme`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profile_id}/basicinfo
     *
     * @tags BasicInfo
     * @name BasicInfoGetBasicInfo
     * @summary Returns basic information for specific profile.
     * @request GET:/profiles/{profileId}/basicinfo
     * @secure
     */
    basicInfoGetBasicInfo: <
      TResponse = ProfileApiDataTransferObjectsBasicInfoBasicInfoDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/basicinfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: PATCH /profiles/{profile_id}/basicinfo
     *
     * @tags BasicInfo
     * @name BasicInfoPatchBasicInfo
     * @summary Patches basic information for specific profile.
     * @request PATCH:/profiles/{profileId}/basicinfo
     * @secure
     */
    basicInfoPatchBasicInfo: <TResponse = unknown, TError = any>(
      profileId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/basicinfo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profile_id}/creditheadings
     *
     * @tags CreditHeadings
     * @name CreditHeadingsGetCreditHeadings
     * @summary Returns credit headings for specific profile.
     * @request GET:/profiles/{profileId}/creditheadings
     * @secure
     */
    creditHeadingsGetCreditHeadings: <
      TResponse = ProfileApiDataTransferObjectsCreditsCreditHeadingDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/creditheadings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Patch /profiles/{profile_id}/creditheadings
     *
     * @tags CreditHeadings
     * @name CreditHeadingsPatchCreditHeadings
     * @summary Pathces credit headings for specific profile.
     * @request PATCH:/profiles/{profileId}/creditheadings
     * @secure
     */
    creditHeadingsPatchCreditHeadings: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsCreditsViewModelsPatchCreditHeadingViewModel[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/creditheadings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Delete /profiles/{profile_id}/credits/{credit_id}
     *
     * @tags Credits
     * @name CreditsDeleteCredit
     * @summary Deletes specified credit for specific profile.
     * @request DELETE:/profiles/{profileId}/credits/{creditId}
     * @secure
     */
    creditsDeleteCredit: <TResponse = unknown, TError = any>(
      profileId: string,
      creditId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits/${creditId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: Put /profiles/{profile_id}/credits/{credit_id}
     *
     * @tags Credits
     * @name CreditsPutCredit
     * @summary Updates specified credit for specific profile.
     * @request PUT:/profiles/{profileId}/credits/{creditId}
     * @secure
     */
    creditsPutCredit: <TResponse = unknown, TError = any>(
      profileId: string,
      creditId: string,
      data: ProfileApiDataTransferObjectsCreditsViewModelsCreditViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits/${creditId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Put /profiles/{profile_id}/credits/
     *
     * @tags Credits
     * @name CreditsBulkPutCredit
     * @summary Updates list of credits for specific profile.
     * @request PUT:/profiles/{profileId}/credits
     * @secure
     */
    creditsBulkPutCredit: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsCreditsViewModelsPutCreditViewModel[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/credits
     *
     * @tags Credits
     * @name CreditsGetCredits
     * @summary Returns credits for specific profile.
     * @request GET:/profiles/{profileId}/credits
     * @secure
     */
    creditsGetCredits: <
      TResponse = ProfileApiDataTransferObjectsCreditsGetCreditsResponseDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Patch /profiles/{profile_id}/credits
     *
     * @tags Credits
     * @name CreditsPatchCredits
     * @summary Patches credits for specific profile.
     * @request PATCH:/profiles/{profileId}/credits
     * @secure
     */
    creditsPatchCredits: <TResponse = unknown, TError = any>(
      profileId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      query?: {
        isHidden?: boolean;
        /** @format int32 */
        creditTypeId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/credits
     *
     * @tags Credits
     * @name CreditsPostCredits
     * @summary Creates credit for specific profile.
     * @request POST:/profiles/{profileId}/credits
     * @secure
     */
    creditsPostCredits: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsCreditsViewModelsCreditViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/credits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/share
     *
     * @tags Email
     * @name EmailShareProfile
     * @summary Sends an email with corresponding data
     * @request POST:/profiles/{profileId}/share
     * @secure
     */
    emailShareProfile: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsEmailShareProfileEmailViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/selfrepresented
     *
     * @tags Email
     * @name EmailSelfRepresented
     * @summary Sends an email from a casting professional to contact a self represented performer.
     * @request POST:/profiles/{profileId}/selfrepresented
     * @secure
     */
    emailSelfRepresented: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsEmailSelfRepresentedEmailViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/selfrepresented`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/selfrepresented/attachments
     *
     * @tags Email
     * @name EmailSelfRepresentedAttachments
     * @summary Provides a set of S3 pre-signed URLs to upload attachments when sending an email to contact a self represented performer.
     * @request POST:/profiles/{profileId}/selfrepresented/attachments
     * @secure
     */
    emailSelfRepresentedAttachments: <TResponse = unknown, TError = any>(
      profileId: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/selfrepresented/attachments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/lookingforrepresentation
     *
     * @tags Email
     * @name EmailLookingForRepresentation
     * @summary Sends an email from an agent to contact a self represented performer.
     * @request POST:/profiles/{profileId}/lookingforrepresentation
     * @secure
     */
    emailLookingForRepresentation: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsEmailAgentToSelfRepresentedEmailViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/lookingforrepresentation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/gallery
     *
     * @tags Gallery
     * @name GalleryGetPhotos
     * @summary Returns photos for specific profile
     * @request GET:/profiles/{profile_id}/gallery
     * @secure
     */
    galleryGetPhotos: <
      TResponse = ProfileApiDataTransferObjectsPhotosGalleryPhotosDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryPutPhotos
     * @request PUT:/profiles/{profile_id}/gallery
     * @secure
     */
    galleryPutPhotos: <
      TResponse = ProfileApiDataTransferObjectsPhotosGalleryPhotosDto,
      TError = any,
    >(
      profileId: string,
      data: ProfileApiDataTransferObjectsPhotosPutGalleryViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Patch /profiles/{profile_id}/gallery
     *
     * @tags Gallery
     * @name GalleryPatchPhotos
     * @summary Patches Photo for specific profile.
     * @request PATCH:/profiles/{profile_id}/gallery
     * @secure
     */
    galleryPatchPhotos: <TResponse = unknown, TError = any>(
      profileId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryPostPhotos
     * @request POST:/profiles/{profile_id}/gallery
     * @secure
     */
    galleryPostPhotos: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsPhotosPostPhotoViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/gallery/{photo_id}
     *
     * @tags GalleryPhoto
     * @name GalleryPhotoGetPhoto
     * @summary Returns specific photo for specific profile
     * @request GET:/profiles/{profile_id}/gallery/{photo_id}
     * @secure
     */
    galleryPhotoGetPhoto: <
      TResponse = ProfileApiDataTransferObjectsPhotosGalleryPhotoDto,
      TError = any,
    >(
      profileId: string,
      photoId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery/${photoId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Patch /profiles/{profile_id}/gallery/{photo_id}
     *
     * @tags GalleryPhoto
     * @name GalleryPhotoPatchPhoto
     * @summary Patches specific photo for specific profile
     * @request PATCH:/profiles/{profile_id}/gallery/{photo_id}
     * @secure
     */
    galleryPhotoPatchPhoto: <TResponse = unknown, TError = any>(
      profileId: string,
      photoId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery/${photoId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Delete /profiles/{profile_id}/gallery/{photo_id}
     *
     * @tags GalleryPhoto
     * @name GalleryPhotoDeletePhoto
     * @summary Removes specific photo for specific profile
     * @request DELETE:/profiles/{profile_id}/gallery/{photo_id}
     * @secure
     */
    galleryPhotoDeletePhoto: <TResponse = unknown, TError = any>(
      profileId: string,
      photoId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery/${photoId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/{profile_id}/gallery/{photo_id}/make_mainphoto
     *
     * @tags GalleryPhoto
     * @name GalleryPhotoMakeMainPhoto
     * @summary Sets specific photo as main photo for specific profile
     * @request POST:/profiles/{profile_id}/gallery/{photo_id}/make_mainphoto
     * @secure
     */
    galleryPhotoMakeMainPhoto: <TResponse = unknown, TError = any>(
      profileId: string,
      photoId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/gallery/${photoId}/make_mainphoto`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hooks
     * @name HooksProcessFilmMakerNotification
     * @request POST:/profiles/hooks/filmmaker
     * @secure
     */
    hooksProcessFilmMakerNotification: <TResponse = unknown, TError = any>(
      data: ProfileApiWebModelsRequestsFilmMakerNotification,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/hooks/filmmaker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hooks
     * @name HooksProcessTagminAvailabilityNotification
     * @request POST:/profiles/hooks/tagmin/availability
     * @secure
     */
    hooksProcessTagminAvailabilityNotification: <
      TResponse = unknown,
      TError = any,
    >(
      data: BaseModelsNotificationsTagminAvailabilityNotification,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/hooks/tagmin/availability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/mainphoto
     *
     * @tags MainPhoto
     * @name MainPhotoGetMainPhoto
     * @summary Returns main photo for specific profile
     * @request GET:/profiles/{profile_id}/mainphoto
     * @secure
     */
    mainPhotoGetMainPhoto: <
      TResponse = ProfileApiDataTransferObjectsPhotosMainPhotoDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/mainphoto`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/mainphoto/{photo_id}
     *
     * @tags MainPhoto
     * @name MainPhotoPatchMainPhoto
     * @summary Patches main photo for specific profile
     * @request PATCH:/profiles/{profile_id}/mainphoto/{photo_id}
     * @secure
     */
    mainPhotoPatchMainPhoto: <TResponse = unknown, TError = any>(
      profileId: string,
      photoId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/mainphoto/${photoId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetVisibleMediaByArtistRef
     * @request GET:/profiles/media/view/{mediaType}/{artistref}
     * @secure
     */
    mediaGetVisibleMediaByArtistRef: <
      TResponse = ProfileApiWebModelsResponsesViewMediaDto,
      TError = unknown | MicrosoftAspNetCoreMvcProblemDetails,
    >(
      mediaType: ProfileApiDataProfileDbEntitiesEnumsMediaType,
      artistref: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/media/view/${mediaType}/${artistref}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetAllMedia
     * @request GET:/profiles/{profileId}/media
     * @secure
     */
    mediaGetAllMedia: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaBaseDto[],
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaCreateNewMediaItem
     * @request POST:/profiles/{profileId}/media
     * @secure
     */
    mediaCreateNewMediaItem: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaBaseDto,
      TError = ProfileApiWebCommonModelsMessageDto,
    >(
      profileId: string,
      data: ProfileApiDataTransferObjectsProfileMediaCreateProfileMediaViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetMediaById
     * @request GET:/profiles/{profileId}/media/{mediaId}
     * @secure
     */
    mediaGetMediaById: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaBaseDto,
      TError = ProfileApiWebCommonModelsMessageDto,
    >(
      profileId: string,
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media/${mediaId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaDeleteMediaItem
     * @request DELETE:/profiles/{profileId}/media/{mediaId}
     * @secure
     */
    mediaDeleteMediaItem: <
      TResponse = ProfileApiWebCommonModelsMessageDto,
      TError = ProfileApiWebCommonModelsMessageDto,
    >(
      profileId: string,
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media/${mediaId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaUpdateMediaItem
     * @request PATCH:/profiles/{profileId}/media/{mediaId}
     * @secure
     */
    mediaUpdateMediaItem: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaBaseDto[],
      TError =
        | ProfileApiCommonExceptionsModelValidationError[]
        | ProfileApiWebCommonModelsMessageDto,
    >(
      profileId: string,
      mediaId: string,
      data: ProfileApiWebModelsRequestsProfileMediaDtoPropertyPatch[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media/${mediaId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetMediaAllocation
     * @request GET:/profiles/{profileId}/media/allocation
     * @secure
     */
    mediaGetMediaAllocation: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaAllocationDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media/allocation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetVisibleMediaByMediaType
     * @request GET:/profiles/{profileId}/media/view/{mediaType}
     * @secure
     */
    mediaGetVisibleMediaByMediaType: <
      TResponse = ProfileApiWebModelsResponsesProfileMediaBaseDto[],
      TError = any,
    >(
      profileId: string,
      mediaType: ProfileApiDataProfileDbEntitiesEnumsMediaType,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/media/view/${mediaType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/{profile_id}/notes/{casting_dir_portal_guid}
     *
     * @tags Notes
     * @name NotesGetCastingDirectorNotes
     * @summary Returns a note for a specific casting director and profile.
     * @request GET:/profiles/{profileId}/notes/{casting_dir_portal_guid}
     * @secure
     */
    notesGetCastingDirectorNotes: <
      TResponse = ProfileApiDataTransferObjectsNotesCastingDirectorNoteDto,
      TError = any,
    >(
      profileId: string,
      castingDirPortalGuid: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/notes/${castingDirPortalGuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: Put /profiles/{profile_id}/notes/{casting_dir_portal_guid}
     *
     * @tags Notes
     * @name NotesPutCastingDirectorNote
     * @summary Updates a note for a specific casting director and profile.
     * @request PUT:/profiles/{profileId}/notes/{casting_dir_portal_guid}
     * @secure
     */
    notesPutCastingDirectorNote: <TResponse = unknown, TError = any>(
      profileId: string,
      castingDirPortalGuid: string,
      data: ProfileApiDataTransferObjectsNotesViewModelsCastingDirectorNoteViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/notes/${castingDirPortalGuid}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Main purpose is to avoid different name spellings for photographers that consistently work with Spotlight Returns matches to part name sent in query string Sample request: Get /profiles/photographers
     *
     * @tags Photographers
     * @name PhotographersGetPhotographers
     * @summary Returns list of photographers approved by Spotlight
     * @request GET:/profiles/photographers
     * @secure
     */
    photographersGetPhotographers: <
      TResponse = ProfileApiDataTransferObjectsPhotographersDto,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/photographers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/productiontypes
     *
     * @tags ProductionTypes
     * @name ProductionTypesGetProductionTypes
     * @summary Returns production types.
     * @request GET:/profiles/productiontypes
     * @secure
     */
    productionTypesGetProductionTypes: <
      TResponse = ProfileApiDataTransferObjectsCreditsProductionTypesDto,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/productiontypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProfileIdentity
     * @name ProfileIdentityGetProfileIdentity
     * @request GET:/profiles/{profileId}/profile-identity
     * @secure
     */
    profileIdentityGetProfileIdentity: <
      TResponse = ProfileApiDataTransferObjectsFreeTextProfileIdentityDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/profile-identity`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProfileIdentity
     * @name ProfileIdentityUpdateProfileIdentity
     * @request PUT:/profiles/{profileId}/profile-identity
     * @secure
     */
    profileIdentityUpdateProfileIdentity: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      profileId: string,
      data: ProfileApiDataTransferObjectsFreeTextProfileIdentityRequest,
      query?: {
        spotlightUserRequiresApproval?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/profile-identity`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/
     *
     * @tags Profiles
     * @name ProfilesGetProfilesFromQuerry
     * @summary Returns default performer profile of user calling this method
     * @request GET:/profiles
     * @secure
     */
    profilesGetProfilesFromQuerry: <
      TResponse = ProfileApiDataTransferObjectsProfilesExtendedProfileDto,
      TError = any,
    >(
      query?: {
        artistRef?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /profiles
     *
     * @tags Profiles
     * @name ProfilesGetProfilesFromBody
     * @summary Returns requested profiles/
     * @request POST:/profiles
     * @secure
     */
    profilesGetProfilesFromBody: <TResponse = unknown, TError = any>(
      data: ProfileApiDataTransferObjectsProfilesSearchViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/a8eb9199-9ba4-4a00-80be-00011305d886
     *
     * @tags Profiles
     * @name ProfilesGetProfileById
     * @summary Returns requested profile by profile_id.
     * @request GET:/profiles/{profile_id}
     * @secure
     */
    profilesGetProfileById: <
      TResponse = ProfileApiDataTransferObjectsProfilesProfileDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesActivate
     * @request POST:/profiles/{profile_id}/activate
     * @secure
     */
    profilesActivate: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/activate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesSuspend
     * @request POST:/profiles/{profile_id}/suspend
     * @secure
     */
    profilesSuspend: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/suspend`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesFilmmakersUnsubscribe
     * @request POST:/profiles/{profile_id}/filmmakers-unsubscribe
     * @secure
     */
    profilesFilmmakersUnsubscribe: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/filmmakers-unsubscribe`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesFilmmakersUnlink
     * @request POST:/profiles/{profile_id}/filmmakers-unlink
     * @secure
     */
    profilesFilmmakersUnlink: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/filmmakers-unlink`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesCreateProfileForPortalGuid
     * @request POST:/profiles/create/{portalGuid}
     * @secure
     */
    profilesCreateProfileForPortalGuid: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      portalGuid: string,
      data: ProfileApiCommonModelsApiEndpointsCreateProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/create/${portalGuid}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesCreateProfile
     * @request POST:/profiles/create
     * @secure
     */
    profilesCreateProfile: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      data: ProfileApiCommonModelsApiEndpointsCreateProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesCreateProfileInternal
     * @request POST:/profiles/create/internal
     * @secure
     */
    profilesCreateProfileInternal: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      data: ProfileApiCommonModelsApiEndpointsCreateProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/create/internal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name ProfilesFilmmakersSsoLink
     * @request GET:/profiles/{profile_id}/filmmakers-sso-link
     * @secure
     */
    profilesFilmmakersSsoLink: <TResponse = unknown, TError = any>(
      profileId: string,
      query?: {
        redirectUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/filmmakers-sso-link`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/artistreference/M271224
     *
     * @tags ProfilesArtistReference
     * @name ProfilesArtistReferenceGetProfile
     * @summary Returns requested profile by legacy identifier artisReference.
     * @request GET:/profiles/artistreference/{artist_ref}
     * @deprecated
     * @secure
     */
    profilesArtistReferenceGetProfile: <
      TResponse = ProfileApiDataTransferObjectsProfilesProfileDto,
      TError = any,
    >(
      artistRef: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/artistreference/${artistRef}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/artistreference/M271224/full
     *
     * @tags ProfilesArtistReference
     * @name ProfilesArtistReferenceGetFullProfile
     * @summary Returns full requested profile by artisReference.
     * @request GET:/profiles/artistreference/{artist_ref}/full
     * @secure
     */
    profilesArtistReferenceGetFullProfile: <
      TResponse = ProfileApiDataTransferObjectsFullProfileFullProfileDto,
      TError = any,
    >(
      artistRef: string,
      query?: {
        /** @default false */
        expandLocations?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/artistreference/${artistRef}/full`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This action is ony available to agents representing multiple performers Sample request: GET /profiles/
     *
     * @tags ProfilesBulk
     * @name ProfilesBulkGetProfilesBulkFromQuery
     * @summary Returns multiple profile based on artist refereced query string.
     * @request GET:/profiles/bulk
     * @deprecated
     * @secure
     */
    profilesBulkGetProfilesBulkFromQuery: <
      TResponse = ProfileApiDataTransferObjectsProfilesExtendedProfileDto,
      TError = any,
    >(
      query?: {
        artistRef?: string[];
        includeGalleryPhotos?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/bulk`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /profiles/
     *
     * @tags ProfilesBulk
     * @name ProfilesBulkGetProfilesBulkFromBody
     * @summary Returns requested profiles.
     * @request POST:/profiles/bulk
     * @secure
     */
    profilesBulkGetProfilesBulkFromBody: <TResponse = unknown, TError = any>(
      data: ProfileApiDataTransferObjectsProfilesSearchBulkViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/bulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/external/M271224
     *
     * @tags ProfilesExternalId
     * @name ProfilesExternalIdGetProfileFromExternalId
     * @summary Returns requested profile by external identifier externalId.
     * @request GET:/profiles/external/{id}
     * @secure
     */
    profilesExternalIdGetProfileFromExternalId: <
      TResponse = ProfileApiDataTransferObjectsProfilesProfileDto,
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/external/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/93786FDF-3377-4F7E-81D4-CE02B0431621/settings
     *
     * @tags ProfilesSettings
     * @name ProfilesSettingsGetSettings
     * @summary Returns discovery screen settings for specific profile.
     * @request GET:/profiles/{profile_Id}/settings
     * @secure
     */
    profilesSettingsGetSettings: <
      TResponse = ProfileApiDataTransferObjectsProfileSettingsProfileSettingsDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: PATCH /profiles/93786FDF-3377-4F7E-81D4-CE02B0431621/settings
     *
     * @tags ProfilesSettings
     * @name ProfilesSettingsPatchSettings
     * @summary Returns settings for specific profile.
     * @request PATCH:/profiles/{profile_Id}/settings
     * @secure
     */
    profilesSettingsPatchSettings: <TResponse = unknown, TError = any>(
      profileId: string,
      data: MicrosoftAspNetCoreJsonPatchOperationsOperation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Does not include sensitive information performer chose not to publish Sample request: GET /profiles/view/8216-3197-7038 Sample response: Details ommited for brevity { id: "be1742aa-9138-49c4-9f16-61ba43bdbb31", artistRef: "M268100", forename: "ANDREI", "surname": "DUMMY-USER", "artistType": 1, "mainPhoto": { "id": "013fc727-ae55-42c4-9419-9246ff250b3c", "photographer": "test", "userFriendlyId": "M00268100-0118", "description": "" }, aboutMe: {..} agents: [..] basicInfo: { facets: [..] hasDisability: false locations: [..] measurements: [{measurementType: "Height", value: 167.6}] playingAgeFrom: 25 playingAgeTo: 30 }, credits: { creditHeadings:[..] credits:[..] }, mediaItems:[..] photos:[..] skills:[..] socialMedia: { website: ""} training: { notes: "Acting, Acting"} _links: { } }
     *
     * @tags ProfileView
     * @name ProfileViewGetByPin
     * @summary Returns all public information accessible on the profile
     * @request GET:/profiles/view/{viewPin}
     * @secure
     */
    profileViewGetByPin: <TResponse = unknown, TError = any>(
      viewPin: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/view/${viewPin}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProfileView
     * @name ProfileViewRedirectByExternalId
     * @request GET:/profiles/view/fm/{externalId}
     * @secure
     */
    profileViewRedirectByExternalId: <TResponse = unknown, TError = any>(
      externalId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/view/fm/${externalId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Iincludes sensitive information performer chose not to publish Sample request: GET /profiles/v1/fetch/276c6a18-7cee-4357-9876-ee3e3d4c7467 Sample response: Details ommited for brevity { id: "be1742aa-9138-49c4-9f16-61ba43bdbb31", artistRef: "M268100", forename: "ANDREI", "surname": "DUMMY-USER", "artistType": 1, "mainPhoto": { "id": "013fc727-ae55-42c4-9419-9246ff250b3c", "photographer": "test", "userFriendlyId": "M00268100-0118", "description": "" }, aboutMe: {..} agents: [..] basicInfo: { facets: [..] hasDisability: false locations: [..] measurements: [{measurementType: "Height", value: 167.6}] playingAgeFrom: 25 playingAgeTo: 30 }, credits: { creditHeadings:[..] credits:[..] }, mediaItems:[..] photos:[..] skills:[..] socialMedia: { website: ""} training: { notes: "Acting, Acting"} _links: { } }
     *
     * @tags ProfileView
     * @name ProfileViewGetByProfileId
     * @summary Returns all information on the profile
     * @request GET:/profiles/v1/fetch/{profileId}
     * @secure
     */
    profileViewGetByProfileId: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/v1/fetch/${profileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profile_id}/skills/
     *
     * @tags Skill
     * @name SkillGetList
     * @summary Returns list of skills for specific profile.
     * @request GET:/profiles/{profileId}/skills
     * @secure
     */
    skillGetList: <
      TResponse = ProfileApiDataTransferObjectsSkillsProfileSkillDto[],
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/skills`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /profiles/{profile_id}/skills/
     *
     * @tags Skill
     * @name SkillCreateSkill
     * @summary Creates skill for specific profile.
     * @request POST:/profiles/{profileId}/skills
     * @secure
     */
    skillCreateSkill: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsSkillsCreateProfileSkillViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/skills`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: PUT /profiles/{profile_id}/skills/{skill_id}
     *
     * @tags Skill
     * @name SkillUpdateSkill
     * @summary Updates specific skill.
     * @request PUT:/profiles/{profileId}/skills/{skillId}
     * @secure
     */
    skillUpdateSkill: <TResponse = unknown, TError = any>(
      profileId: string,
      skillId: string,
      data: ProfileApiDataTransferObjectsSkillsUpdateProfileSkillViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/skills/${skillId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: DELETE /profiles/{profile_id}/skills/{skill_id}
     *
     * @tags Skill
     * @name SkillDeleteSkill
     * @summary Deletes specific skill.
     * @request DELETE:/profiles/{profileId}/skills/{skillId}
     * @secure
     */
    skillDeleteSkill: <TResponse = unknown, TError = any>(
      profileId: string,
      skillId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/skills/${skillId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialMedia
     * @name SocialMediaStartInstagramAuth
     * @request POST:/profiles/{profileId}/social/instagram/start
     * @secure
     */
    socialMediaStartInstagramAuth: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/social/instagram/start`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profile_id}/social/
     *
     * @tags SocialMedia
     * @name SocialMediaGetSocialMedia
     * @summary Returns social media contacts for specific profile.
     * @request GET:/profiles/{profileId}/social
     * @secure
     */
    socialMediaGetSocialMedia: <
      TResponse = ProfileApiDataTransferObjectsSocialMediaSocialMediaDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/social`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: PUT /profiles/31c39315-238c-4718-b48f-26ee8456d81f/social/
     *
     * @tags SocialMedia
     * @name SocialMediaPutSocialMedia
     * @summary Updates social information for specific user.
     * @request PUT:/profiles/{profileId}/social
     * @secure
     */
    socialMediaPutSocialMedia: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsSocialMediaSocialMediaViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/social`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialMedia
     * @name SocialMediaGetAccounts
     * @request GET:/profiles/{profileId}/social/accounts
     * @secure
     */
    socialMediaGetAccounts: <TResponse = unknown, TError = any>(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/social/accounts`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialMedia
     * @name SocialMediaDisconnectAccount
     * @request DELETE:/profiles/{profileId}/social/accounts/{accountId}
     * @secure
     */
    socialMediaDisconnectAccount: <TResponse = unknown, TError = any>(
      profileId: string,
      accountId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/social/accounts/${accountId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profile_id}/training/
     *
     * @tags Training
     * @name TrainingGetTraining
     * @summary Returns training information for specific profile.
     * @request GET:/profiles/{profileId}/training
     * @secure
     */
    trainingGetTraining: <
      TResponse = ProfileApiDataTransferObjectsFreeTextTrainingDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/training`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: PUT /profiles/{profile_id}/training/
     *
     * @tags Training
     * @name TrainingPutTraining
     * @summary Updates training information for specific profile.
     * @request PUT:/profiles/{profileId}/training
     * @secure
     */
    trainingPutTraining: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsFreeTextTrainingViewModel,
      query?: {
        spotlightUserRequiresApproval?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/training`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: GET /profiles/{profileId}/unavailability
     *
     * @tags Unavailability
     * @name UnavailabilityGetUnavailabilities
     * @summary Returns unavailability records for a specific profile.
     * @request GET:/profiles/{profileId}/unavailability
     * @secure
     */
    unavailabilityGetUnavailabilities: <
      TResponse = ProfileApiDataTransferObjectsUnavailabilityUnavailabilityDto,
      TError = any,
    >(
      profileId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/unavailability`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /profiles/{profileId}/unavailability
     *
     * @tags Unavailability
     * @name UnavailabilityPostUnavailability
     * @summary Creates an unavailability record for a specific profile.
     * @request POST:/profiles/{profileId}/unavailability
     * @secure
     */
    unavailabilityPostUnavailability: <TResponse = unknown, TError = any>(
      profileId: string,
      data: ProfileApiDataTransferObjectsUnavailabilityViewModelsUnavailabilityViewModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/unavailability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: DELETE /profiles/{profileId}/unavailability/{id}
     *
     * @tags Unavailability
     * @name UnavailabilityDeleteUnavailability
     * @summary Deletes an unavailability record for a specific profile.
     * @request DELETE:/profiles/{profileId}/unavailability/{id}
     * @secure
     */
    unavailabilityDeleteUnavailability: <TResponse = unknown, TError = any>(
      profileId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/${profileId}/unavailability/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: Post /profiles/upload/photo/RequestUrl
     *
     * @tags UploadPhoto
     * @name UploadPhotoUploadPhotoByRequestUrl
     * @summary returns presigned url for photo upload
     * @request POST:/profiles/upload/photo/requesturl
     * @secure
     */
    uploadPhotoUploadPhotoByRequestUrl: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/upload/photo/requesturl`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: Get /profiles/upload/photo/{file_validation_id}
     *
     * @tags UploadPhoto
     * @name UploadPhotoGetValidationStatus
     * @summary returns validation status when file has been uploaded and awaits automated validation
     * @request GET:/profiles/upload/photo/{file_validation_id}
     * @secure
     */
    uploadPhotoGetValidationStatus: <
      TResponse = ProfileApiDataTransferObjectsFileValidationDto,
      TError = any,
    >(
      fileValidationId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/profiles/upload/photo/${fileValidationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags InstagramAuth
     * @name InstagramAuthCallback
     * @summary OAuth callback endpoint. Performs token exchange and persistence, then returns a redirect to the FE app..
     * @request GET:/auth/instagram/callback
     * @secure
     */
    instagramAuthCallback: <TResponse = unknown, TError = any>(
      query?: {
        code?: string;
        state?: string;
        error?: string;
        error_reason?: string;
        error_description?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/auth/instagram/callback`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  marketing = {
    /**
     * No description
     *
     * @tags Marketing
     * @name MarketingSetCookie
     * @summary Returns a cookie containg the Portal GUID of the user.
     * @request GET:/marketing/cookie
     * @secure
     */
    marketingSetCookie: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/marketing/cookie`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Marketing
     * @name MarketingGetUserDetails
     * @summary Returns user data from a cookie containg the Portal GUID.
     * @request GET:/marketing/user
     * @secure
     */
    marketingGetUserDetails: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/marketing/user`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  viewPin = {
    /**
     * No description
     *
     * @tags ProfileView
     * @name ProfileViewGetMainPhotoByPin
     * @request GET:/{viewPin}/mainphoto
     * @secure
     */
    profileViewGetMainPhotoByPin: <TResponse = unknown, TError = any>(
      viewPin: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/${viewPin}/mainphoto`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  content = {
    /**
     * @description Sample request: GET /content/{langCode}/application/
     *
     * @tags UmbracoProxy
     * @name UmbracoProxyGetApplicationContent
     * @summary Returns application content for ProfileFE.
     * @request GET:/content/{langCode}/application
     * @secure
     */
    umbracoProxyGetApplicationContent: <TResponse = unknown, TError = any>(
      langCode: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/content/${langCode}/application`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: GET /content/{langCode}/navigation/{userType}
     *
     * @tags UmbracoProxy
     * @name UmbracoProxyGetNavigationContent
     * @summary Returns navigation content for ProfileFE.
     * @request GET:/content/{langCode}/navigation/{userType}
     * @secure
     */
    umbracoProxyGetNavigationContent: <TResponse = unknown, TError = any>(
      langCode: string,
      userType: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/content/${langCode}/navigation/${userType}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  whoami = {
    /**
     * @description Sample request: GET /whoami
     *
     * @tags WhoAmI
     * @name WhoAmIWhoAmI
     * @summary Returns discovered information about profile
     * @request GET:/whoami
     * @secure
     */
    whoAmIWhoAmI: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/whoami`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
